import React from 'react';

const AccountLoader = () => {
    return (
        <div className="show-load">
            <div className="loading">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )
}

export default AccountLoader;